import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const STEPS = [
  {
    title:  'Sua jornada começa agora',
    body:   'Você desbloqueou acesso aos 12 sistemas. Vamos guiá-la pelos primeiros passos.',
    cta:    'Vamos lá',
    action: null as string | null,
  },
  {
    title:  'Passo 1: Seu mapa natal',
    body:   'O ponto de partida de tudo. Uma leitura profunda do céu no momento do seu nascimento.',
    cta:    'Ler meu mapa',
    action: '/mapa',
  },
  {
    title:  'Passo 2: Previsões diárias',
    body:   'Configure o horário em que você quer receber sua mensagem do dia.',
    cta:    'Configurar',
    action: '/configuracoes/notificacoes',
  },
  {
    title:  'Passo 3: Os 12 sistemas',
    body:   'Tarô, Numerologia, Design Humano, Quiromancia... explore todos no seu tempo.',
    cta:    'Descobrir tudo',
    action: '/descobrir',
  },
];

export function WelcomeModal() {
  const [params, setParams] = useSearchParams();
  const navigate            = useNavigate();
  const [open, setOpen]     = useState(false);
  const [step, setStep]     = useState(0);

  useEffect(() => {
    if (params.get('welcome') === '1') setOpen(true);
  }, [params]);

  if (!open) return null;

  const current = STEPS[step];

  function close() {
    setOpen(false);
    params.delete('welcome');
    setParams(params, { replace: true });
  }

  function next() {
    if (current.action) navigate(current.action);
    if (step < STEPS.length - 1) setStep(s => s + 1);
    else close();
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0D1130]/95 backdrop-blur-sm p-4"
    >
      <div className="max-w-md w-full bg-[#0D1130] border border-[#C9A84C]/30 rounded-sm p-8 text-center">
        <div className="text-[#C9A84C] text-2xl tracking-[8px] mb-2" aria-hidden="true">✦</div>
        <p className="text-[#F5ECD7]/60 text-xs tracking-[3px] uppercase mb-6">
          Passo {step + 1} de {STEPS.length}
        </p>
        <h2 id="welcome-title" className="text-[#C9A84C] text-2xl font-light mb-4">
          {current.title}
        </h2>
        <p className="text-[#F5ECD7] leading-relaxed mb-8">{current.body}</p>

        {/* Progress dots */}
        <div className="flex justify-center gap-2 mb-8">
          {STEPS.map((_, i) => (
            <span
              key={i}
              className={`w-1.5 h-1.5 rounded-full transition-colors ${
                i === step ? 'bg-[#C9A84C]' : 'bg-[#C9A84C]/30'
              }`}
            />
          ))}
        </div>

        <div className="flex gap-3 justify-center">
          <button
            onClick={close}
            className="px-6 py-3 text-[#F5ECD7]/60 text-xs tracking-[2px] uppercase hover:text-[#F5ECD7] transition-colors"
          >
            Pular
          </button>
          <button
            onClick={next}
            className="px-8 py-3 bg-[#C9A84C] text-[#0D1130] text-xs tracking-[2px] uppercase font-bold hover:bg-[#C9A84C]/90 transition-colors"
          >
            {current.cta}
          </button>
        </div>
      </div>
    </div>
  );
}
